import React from 'react';
import { useDispatch } from 'react-redux';
import AuthorizePaymentModal, {
    AuthorizePaymentModalProps,
} from '../presentational/AuthorizePaymentModal';

interface AuthorizePaymentModalContainerProps {
    paymentInfo: AuthorizePaymentModalProps['data'];
    hideModal: AuthorizePaymentModalProps['handleClose'];
}

const AuthorizePaymentModalContainer = ({
    hideModal,
    paymentInfo,
}: AuthorizePaymentModalContainerProps) => {
    const dispatch = useDispatch();

    const handleClose = () => dispatch(hideModal());

    return (
        <div className="authorize-payment-modal">
            <AuthorizePaymentModal
                handleClose={handleClose}
                data={paymentInfo}
            />
        </div>
    );
};

export default AuthorizePaymentModalContainer;
